/* COY parallax. Text glides; photos and video drift inside their frames.
   Loaded deferred from theme.liquid. Scope comes from the script tag:
   data-coy-parallax-scope="main" on articles (the whole page) and ".slideshow"
   on the magazine page and collections (hero slideshow only, never product
   grids, whose eyewear framing must stay exact). Product imagery is skipped
   everywhere: .card--product, or any card whose nearby link goes to a product
   (article content cards link via a sibling button, not a wrapping link).
   Brand logos (logo lists) never move: zooming would crop the mark.
   Writes ONLY the individual translate and scale properties (never transform,
   animation or transition) so it composes with reveals, zooms, and Swiper's own
   data-swiper-parallax, which moves .slideshow__content-wrapper, not the group.
   Overlays never move. Tune TEXT_PX, IMG_PCT, EASE. Rollback: theme.liquid. */
(function () {
  if (window.__coyParallax) return;
  window.__coyParallax = true;

  var me = document.currentScript;
  var SCOPE = (me && me.getAttribute('data-coy-parallax-scope')) || 'main';

  var TEXT = [
    ['.slideshow__content-group', 1],
    ['.hero-content', 1],
    ['.media-banner__headings', 1],
    ['.media-banner__information', 0.55],
    ['.titles', 0.75]
  ];
  var SKIP = '[class*="blog_posts_custom_CNw7FR"], a[href*="/products/"], .card--product, [class*="product-card"], [class*="logo-card"], [class*="logo-list"]';
  // Text INSIDE a card never moves: it would float away from its own card.
  // The card's image still drifts. Section headings above a row of cards still glide.
  // COY (4 NOV): .content-cards keeps the "Our suggestions" heading on articles still too.
  var TEXT_SKIP = '.content-card, .content-cards, .article-card, .collection-card, .logo-card, .blog-posts-card';
  var TEXT_PX = [16, 9];
  var IMG_PCT = [0.04, 0.03];
  var EASE = 0.09; // COY (4 NOV): was 0.12; softer, more premium glide

  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)');
  var small = window.matchMedia('(max-width: 749px)');
  var root = document.querySelector('main') || document.body;
  var items = [];
  var seen = new WeakSet();
  var raf = 0, last = 0, timer = 0;

  function cs(el, pseudo) { return window.getComputedStyle(el, pseudo || null); }
  function set(rec, el, prop, val) { rec.undo.push([el, prop, el.style[prop]]); el.style[prop] = val; }
  function autoLayer(s) { return s.position !== 'static' && s.zIndex === 'auto'; }
  function cssSmoothed(el) {
    var s = cs(el);
    return /(^|,)\s*(all|translate|scale)\s*(,|$)/.test(s.transitionProperty) &&
      s.transitionDuration.split(',').some(function (d) { return parseFloat(d) > 0; });
  }
  function sinkNeeded(unit, parent) {
    var b = cs(parent, '::before');
    if (b.content !== 'none' && b.content !== 'normal' && autoLayer(b)) return true;
    for (var s = unit.previousElementSibling; s; s = s.previousElementSibling) {
      if (autoLayer(cs(s))) return true;
    }
    return false;
  }

  function productImagery(media, parent) {
    if (media.closest('.slideshow')) return false;
    for (var e = parent, n = 0; e && e !== root && n < 3; e = e.parentElement, n++) {
      if (e.querySelector('a[href*="/products/"]')) return true;
    }
    return false;
  }

  function scopes() {
    return SCOPE === 'main' ? [root] : Array.prototype.slice.call(root.querySelectorAll(SCOPE));
  }

  function scan() {
    if (reduce.matches) return;
    scopes().forEach(function (scope) {
      TEXT.forEach(function (t) {
        scope.querySelectorAll(t[0]).forEach(function (el) {
          if (seen.has(el)) return;
          seen.add(el);
          if (el.closest(SKIP) || el.closest(TEXT_SKIP)) return;
          // COY (4 NOV): text already on screen at load gets its current position as the
          // baseline (p0), so it stays exactly where it rendered and only moves on scroll.
          var er = el.getBoundingClientRect(), evh = window.innerHeight;
          var p0 = 0;
          if (er.height && er.top < evh && er.bottom > 0) {
            p0 = (er.top + er.height / 2 - evh / 2) / (evh / 2 + er.height / 2);
            p0 = p0 < -1 ? -1 : p0 > 1 ? 1 : p0;
          }
          items.push({ img: false, el: el, frame: el, depth: t[1], p0: p0, fresh: true, y: 0, s: 1, wy: 0, ws: 1, css: cssSmoothed(el), undo: [] });
        });
      });
      scope.querySelectorAll('img, video').forEach(function (media) {
        if (seen.has(media)) return;
        if (media.closest(SKIP) || (media.tagName === 'IMG' && media.closest('video'))) { seen.add(media); return; }
        var unit = media.parentElement && media.parentElement.tagName === 'PICTURE' ? media.parentElement : media;
        var parent = unit.parentElement;
        if (!parent) return;
        if (productImagery(media, parent)) { seen.add(media); return; }
        var ir = media.getBoundingClientRect(), pr = parent.getBoundingClientRect();
        if (ir.height < 120 || ir.width < pr.width * 0.9 || ir.height < pr.height * 0.9) return;
        seen.add(media);
        var ivh = window.innerHeight, ip0 = 0;
        if (pr.height && pr.top < ivh && pr.bottom > 0) {
          ip0 = (pr.top + pr.height / 2 - ivh / 2) / (ivh / 2 + pr.height / 2);
          ip0 = ip0 < -1 ? -1 : ip0 > 1 ? 1 : ip0;
        }
        var rec = { img: true, el: media, frame: parent, p0: ip0, fresh: true, y: 0, s: 1, wy: 0, ws: 1, css: cssSmoothed(media), undo: [] };
        var ps = cs(parent);
        if (ps.overflowX === 'visible' && ps.overflowY === 'visible') {
          set(rec, parent, 'clipPath', 'inset(0 round ' + ps.borderRadius + ')');
        }
        if (sinkNeeded(unit, parent)) {
          set(rec, parent, 'isolation', 'isolate');
          if (cs(media).position === 'static') set(rec, media, 'position', 'relative');
          set(rec, media, 'zIndex', '-1');
        }
        items.push(rec);
      });
    });
  }

  function frame(now) {
    raf = 0;
    var dt = last ? Math.min(64, now - last) : 16.667;
    last = now;
    var k = 1 - Math.pow(1 - EASE, dt / 16.667);
    var vh = window.innerHeight, m = small.matches ? 1 : 0, busy = false;
    for (var i = items.length - 1; i >= 0; i--) {
      var it = items[i];
      if (!it.el.isConnected) { items.splice(i, 1); continue; }
      var r = it.frame.getBoundingClientRect();
      var top = it.img ? r.top : r.top - it.wy;
      var h = r.height;
      if (!h || top > vh + 240 || top + h < -240) continue;
      var p = (top + h / 2 - vh / 2) / (vh / 2 + h / 2);
      p = p < -1 ? -1 : p > 1 ? 1 : p;
      var ty, ts = 1;
      if (it.img) { ty = -(p - (it.p0 || 0)) * IMG_PCT[m] * h; ts = 1 + IMG_PCT[m] * 2 + 0.01; }
      else { ty = (p - (it.p0 || 0)) * TEXT_PX[m] * it.depth; }
      // COY (4 NOV): first frame snaps straight to position — no load-time glide/zoom.
      // Easing applies only to scroll-driven movement after that.
      var snap = it.css || it.fresh;
      it.fresh = false;
      var ny = snap ? ty : it.y + (ty - it.y) * k;
      var ns = snap ? ts : it.s + (ts - it.s) * k;
      if (Math.abs(ty - ny) < 0.05 && Math.abs(ts - ns) < 0.0005) { ny = ty; ns = ts; } else { busy = true; }
      it.y = ny; it.s = ns;
      var wy = Math.round(ny * 100) / 100;
      if (wy !== it.wy) { it.wy = wy; it.el.style.translate = '0 ' + wy + 'px'; }
      if (it.img) {
        var ws = Math.round(ns * 10000) / 10000;
        if (ws !== it.ws) { it.ws = ws; it.el.style.scale = String(ws); }
      }
    }
    if (busy) raf = window.requestAnimationFrame(frame); else last = 0;
  }

  function kick() {
    if (!raf) raf = window.requestAnimationFrame(frame);
    window.clearTimeout(timer);
    timer = window.setTimeout(start, 300);
  }
  function start() { scan(); if (!raf) raf = window.requestAnimationFrame(frame); }
  function restore() {
    if (raf) window.cancelAnimationFrame(raf);
    raf = 0; last = 0;
    items.forEach(function (it) {
      it.el.style.translate = '';
      if (it.img) it.el.style.scale = '';
      for (var j = it.undo.length - 1; j >= 0; j--) it.undo[j][0].style[it.undo[j][1]] = it.undo[j][2];
    });
    items = [];
    seen = new WeakSet();
  }

  window.addEventListener('scroll', kick, { passive: true });
  window.addEventListener('resize', kick, { passive: true });
  window.addEventListener('load', start);
  if (reduce.addEventListener) {
    reduce.addEventListener('change', function () { if (reduce.matches) restore(); else start(); });
  }
  new MutationObserver(function () {
    window.clearTimeout(timer);
    timer = window.setTimeout(start, 300);
  }).observe(root, { childList: true, subtree: true });

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();

})();